import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Link as RouterLink } from 'react-router-dom';
import toTitleCase from '@clearscore/normalize.title-case';

import { themes } from './constants';
import styles from './text-link.css';

const TextLink = ({ children, theme, href, title, isNewTab, onClick, isSimpleLink }) => {
    const linkProps = {
        className: cx(styles.component, styles[`isTheme${toTitleCase(theme)}`], {
            [styles.isSimpleLink]: isSimpleLink,
        }),
        onClick,
        title,
    };
    const isInternalLink =
        !isNewTab &&
        href &&
        !href.startsWith('http') &&
        !href.startsWith('mailto:') &&
        !href.startsWith('tel:') &&
        !href.startsWith('#');

    return isInternalLink ? (
        <RouterLink {...linkProps} to={href}>
            {children}
        </RouterLink>
    ) : (
        <a
            {...linkProps}
            href={href}
            {...(isNewTab && {
                rel: 'noopener noreferrer',
                target: '_blank',
            })}
        >
            {children}
        </a>
    );
};

TextLink.propTypes = {
    children: PropTypes.node.isRequired,
    theme: PropTypes.oneOf(Object.values(themes)),
    href: PropTypes.string,
    title: PropTypes.string,
    onClick: PropTypes.func,
    isNewTab: PropTypes.bool,
    isSimpleLink: PropTypes.bool,
};

TextLink.defaultProps = {
    theme: themes.LIGHT,
    href: undefined,
    title: null,
    onClick: null,
    isNewTab: false,
    isSimpleLink: false,
};

TextLink.themes = themes;

export default TextLink;
